import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import EmptyState from "../../components/EmptyState/EmptyState";
import { Modal, Button, Row, Col, Dropdown } from "react-bootstrap";
import ModalPreview from "./ModalPreview";
import useTemp from "../../assets/images/useTemp.png";
import { getModuleDetailsAsync } from "../../reducers/module-reducers";
import { getSequenceDetailsAsync } from "../../reducers/sequence-reducers";
import { getProcessesDetailsAsync } from "../../reducers/processes-reducers";
import { useDispatch, useSelector } from "react-redux";
import { IconTempDelete, IconDots, PreviewIcon } from "../../icons/Icons";
import Select from "react-select";
import moment from "moment";

const ListPreview = ({
  templateDetail,
  formDataReady,
  type,
  selectedData,
  handleDeleteClick,
  deleteId,
}) => {
  const [previewModal, setPreviewModal] = useState(false);
  const [moduleDetails, setAdditionalStorage] = useState(null);
  const [SequencesDetails, setSequencesDetails] = useState(null);
  const [ProcessesDetails, setProcessesDetails] = useState(null);
  const [listData, setlistData] = useState(null);
  const [moduleData, setModuletData] = useState(null);
  const [contentList, setContentList] = useState([]);
  const [userData, setUserData] = useState(deleteId);
  const dispatch = useDispatch();
  const navigate = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    console.log(userData, "tester123");
    if (userData) {
      getDetails();
    }
  }, [userData]);

  const getDetails = async () => {
    setIsLoading(true);
    if (!userData) {
      return;
    }
    if (type === "module") {
      const data = await dispatch(getModuleDetailsAsync(userData));
      setAdditionalStorage(data.payload);
      const list = [];
      if (data.payload.pages !== undefined && data.payload.pages.length > 0) {
        data.payload.pages.map((m) => {
          list.push({ ...m, contenttype: "pages" });
        });
      }
      if (data.payload.forms !== undefined && data.payload.forms.length > 0) {
        data.payload.forms.map((m) => {
          list.push({ ...m, contenttype: "forms" });
        });
      }
      setModuletData(list ?? []);
    } else if (type === "process") {
      const data = await dispatch(getProcessesDetailsAsync(userData));
      setProcessesDetails(data.payload);
      setContentList(data.payload?.content ?? []);
    } else {
      const data = await dispatch(getSequenceDetailsAsync(userData));
      setSequencesDetails(data.payload);
      setlistData(data.payload?.modules ?? []);
    }
    setIsLoading(false);
  };

  const OnEditFormContent = async (id) => {
    // if (!userData) {
    //   return;
    // }

    let route = "";
    let routeData = null;

    if (type === "process") {
      const data = await dispatch(getProcessesDetailsAsync(id));
      setProcessesDetails(data.payload);
      setContentList(data.payload?.content ?? []);
      route = `/authoring/processes/edit`;
      routeData = { propsData: data?.payload, operationType: "Edit" };
    } else if (type === "sequence") {
      const data = await dispatch(getSequenceDetailsAsync(id));
      setSequencesDetails(data.payload);
      setlistData(data.payload?.modules ?? []);
      route = `/authoring/sequences/edit`;
      routeData = { propsData: data?.payload, operationType: "Edit" };
    } else if (type === "module") {
      const data = await dispatch(getModuleDetailsAsync(id));
      setAdditionalStorage(data.payload);
      const list = [];
      if (data.payload.pages !== undefined && data.payload.pages.length > 0) {
        data.payload.pages.map((m) => {
          list.push({ ...m, contenttype: "pages" });
        });
      }
      if (data.payload.forms !== undefined && data.payload.forms.length > 0) {
        data.payload.forms.map((m) => {
          list.push({ ...m, contenttype: "forms" });
        });
      }
      setModuletData(list ?? []);
      route = `/authoring/modules/create`;
      routeData = { propsData: data.payload ?? [], operationType: "Edit" };
    }

    navigate.push(route, routeData);
  };

  const handleUseClick = (id) => {
    // debugger
    // if (userData) {
    OnEditFormContent(id);
    // } else {
    //   setUserData(id);
    // }
  };

  return (
    <>
      <div className="p-32 ">
        {/* <div className="row">
          <div className="col-md-12 pb-4">
            <h5>For you</h5> 
          </div>
        </div> */}
        {/* <div className="row justify-content-end">
          <div className="col-2">
            <div className="form-group mySelect">
              <Select
                isSearchable={false}
                name="recommendedTimeDurationType"
                className="select"
                classNamePrefix="selectCustom"
                options=""
                value=""
                onChange={() => {}}
              />
            </div>
          </div>
        </div> */}
        <div className="row gx-4 gy-4">
          {selectedData != null &&
            selectedData?.length > 0 &&
            selectedData?.map((c, index) => (
              <>
                {c.type === "Process" && (
                  // <div className="col-md-4 mb-2" key={c.id}>
                  //   <div className="card p-2 mb-4 mx-1 mb-4">
                  //     {/* <p className="card-title text-secondary-400 text-12 m-0 px-1">{c.type}</p> */}
                  //     <div className="temBtn d-flex align-items-start gap-3">
                  //       <Button
                  //         className="btn-sm btn-secondary"
                  //         onClick={() => handleUseClick(c.id)}
                  //       >
                  //         Use
                  //       </Button>

                  //       <Button
                  //         variant="white"
                  //         className="btn-sm btn-white"
                  //         onClick={() => {
                  //           setUserData(c.id);
                  //           setPreviewModal(true);
                  //         }}
                  //       >
                  //         Preview
                  //       </Button>
                  //     </div>
                  //     <img className="card-img-top" src={useTemp} alt="" />
                  //     <div className="d-flex justify-content-between py-2 mt-1 pe-2">
                  //       {" "}
                  //       <h5 className="card-text text-gray-100 font-medium px-1 singleLineEc pe-5">
                  //         {c.title}
                  //       </h5>
                  //       <Button
                  //         className="p-0 m-0 btn btn-Deleteico"
                  //         onClick={() => handleDeleteClick("Process", c.id)}
                  //       >
                  //         <IconTempDelete />
                  //       </Button>
                  //     </div>
                  //   </div>
                  // </div>
                  <div className="col-md-4" key={c.id}>
                    <div className="card p-0 templateCard">
                      <div className="d-flex justify-content-between align-items-start ps-20 pe-3 pt-10">
                        <div className="flex-1">
                          <p className="text-xs text-gray-100 m-0">
                            Process Name
                          </p>
                          <h3 className="text-gray-100 font-medium my-1">
                            {c.title}
                          </h3>
                          <p className="text-xs text-gray-300 m-0">
                            Created on 
                            {c.createdDate &&
                              moment(c.createdDate).format("MMM D, YYYY")}
                          </p>
                        </div>
                        <Dropdown className="tableDropdown">
                          <Dropdown.Toggle>
                            <IconDots />
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="py-0">
                            <button
                              className="dropdown-item d-flex justify-content-start align-items-center gap-1"
                              onClick={() => {
                                setUserData(c.id);
                                setPreviewModal(true);
                              }}
                            >
                              <PreviewIcon />
                              <span>Preview</span>
                            </button>

                            <button
                              className="dropdown-item d-flex justify-content-start align-items-center gap-1"
                              onClick={() => handleDeleteClick("Process", c.id)}
                            >
                              <IconTempDelete />
                              <span>Delete</span>
                            </button>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>

                      <div className="d-flex justify-content-start align-items-start gap-4 mt-12 ps-20">
                        <div className="text-gray-300 col-4">
                          <p className="text-md m-0">Sequences</p>
                          <p className="text-lg mt-2 mb-0">
                            {c?.sequenceCount}
                          </p>
                        </div>
                        <div className="text-gray-300 col-4">
                          <p className="text-md m-0">Module</p>
                          <p className="text-lg mt-2 mb-0">
                            {c?.moduleCount}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex justify-content-end pt-10 mb-10 pe-3 mt-3 border-top border-gray-500">
                        <button
                          className="text-lg text-primary-100 font-bold"
                          onClick={() => handleUseClick(c.id)}
                        >
                          Use
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {c.type === "Sequence" && (
                  <div className="col-md-4" key={c.id}>
                    <div className="card p-0 templateCard">
                      <div className="d-flex gap-2 align-items-start ps-20 pe-3 pt-10">
                        <div className="w-100 overflow-hidden">
                          <p className="text-xs text-gray-100 m-0">
                            Sequence Name
                          </p>
                          <h3 className="text-gray-100 font-medium my-1 text-truncate wordWrap w-full">
                            {c.title}
                          </h3>
                          <p className="text-xs text-gray-300 m-0">
                            Created on 
                            {c.createdDate &&
                              moment(c.createdDate).format("MMM D, YYYY")}
                          </p>
                        </div>
                        <Dropdown className="tableDropdown flex-grow-1">
                          <Dropdown.Toggle>
                            <IconDots />
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="py-0">
                            <button
                              className="dropdown-item"
                              onClick={() => {
                                setUserData(c.id);
                                setPreviewModal(true);
                              }}
                            >
                              <PreviewIcon /> Preview
                            </button>

                            <button
                              className="dropdown-item"
                              onClick={() =>
                                handleDeleteClick("Sequence", c.id)
                              }
                            >
                              <IconTempDelete /> Delete
                            </button>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>

                      <div className="d-flex justify-content-start align-items-start gap-4 mt-12 ps-20">
                        {/* <div className="text-gray-300 col-4">
                            <p className="text-md m-0">Sequences</p>
                            <p className="text-lg mt-2 mb-0">{SequencesDetails?.usedInProcesses ?? 0}</p>
                          </div> */}
                        <div className="text-gray-300 col-4">
                          <p className="text-md m-0">Module</p>
                          <p className="text-lg mt-2 mb-0">
                            {c?.moduleCount}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex justify-content-end pt-10 mb-10 pe-3 mt-3 border-top border-gray-500">
                        <button
                          className="text-lg text-primary-100 font-bold"
                          onClick={() => handleUseClick(c.id)}
                        >
                          Use
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {c.type === "Module" && (
                  // <div className="col-md-4 mb-2" key={c.id}>
                  //   <div className="card p-2 mb-4 mx-1 mb-4">
                  //     {/* <p className="card-title text-secondary-400 text-12 m-0 px-1">{c.type}</p> */}
                  //     <div className="temBtn d-flex align-items-start gap-3">
                  //       <Button
                  //         className="btn-sm btn-secondary"
                  //         onClick={() => handleUseClick(c.id)}
                  //       >
                  //         Use
                  //       </Button>

                  //       <Button
                  //         className="btn-sm btn-white"
                  //         onClick={() => {
                  //           setPreviewModal(true);
                  //           setUserData(c.id);
                  //         }}
                  //       >
                  //         Preview
                  //       </Button>
                  //     </div>
                  //     <img className="card-img-top" src={useTemp} alt="" />
                  //     <div className="d-flex justify-content-between py-2 mt-1 pe-2">
                  //       {" "}
                  //       <h5 className="card-text text-gray-100 font-medium px-1 singleLineEc pe-5">
                  //         {c.title}
                  //       </h5>
                  //       <Button
                  //         className="p-0 m-0 btn btn-Deleteico"
                  //         onClick={() => handleDeleteClick("Module", c.id)}
                  //       >
                  //         <IconTempDelete />
                  //       </Button>
                  //     </div>
                  //   </div>
                  //   {/* )}  */}
                  // </div>
                  <div className="col-md-4" key={c.id}>
                    <div className="card p-0 templateCard">
                      <div className="d-flex justify-content-between align-items-start ps-20 pe-3 pt-10">
                        <div>
                          <p className="text-xs text-gray-100 m-0">
                            Module Name
                          </p>
                          <h3 className="text-gray-100 font-medium my-1">
                            {c.title}
                          </h3>
                          <p className="text-xs text-gray-300 m-0">
                            Created on 
                            {c.createdDate &&
                              moment(c.createdDate).format("MMM D, YYYY")}
                          </p>
                        </div>
                        <Dropdown className="tableDropdown">
                          <Dropdown.Toggle>
                            <IconDots />
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="py-0">
                            <button
                              className="dropdown-item d-flex justify-content-start align-items-center gap-1"
                              onClick={() => {
                                setUserData(c.id);
                                setPreviewModal(true);
                              }}
                            >
                              <PreviewIcon />
                              <span>Preview</span>
                            </button>

                            <button
                              className="dropdown-item d-flex justify-content-start align-items-center gap-1"
                              onClick={() => handleDeleteClick("Module", c.id)}
                            >
                              <IconTempDelete />
                              <span>Delete</span>
                            </button>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>

                      <div className="d-flex justify-content-start align-items-start gap-4 mt-12 ps-20">
                        <div className="text-gray-300 col-4">
                          <p className="text-md m-0">Forms</p>
                          <p className="text-lg mt-2 mb-0">{c.formCount}</p>
                        </div>
                        <div className="text-gray-300 col-4">
                          <p className="text-md m-0">Pages</p>
                          <p className="text-lg mt-2 mb-0">{c.pageCount}</p>
                        </div>
                      </div>
                      <div className="d-flex justify-content-end pt-10 mb-10 pe-3 mt-3 border-top border-gray-500">
                        <button
                          className="text-lg text-primary-100 font-bold"
                          onClick={() => handleUseClick(c.id)}
                        >
                          Use
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ))}
        </div>

        {!selectedData?.length > 0 && formDataReady === true ? (
          <div
            className="libraryTemplateEmpty"
            style={{ height: "calc(100vh - 11.875rem)" }}
          >
            <EmptyState message="No template found" />
          </div>
        ) : null}
      </div>
      <Modal
        className="come-from-modal right manageTeamsActivityModal"
        centered
        show={previewModal}
        // onHide={() => setActivityModal(false)}
      >
        <ModalPreview
          handleModal={setPreviewModal}
          type={type}
          detail={moduleDetails}
          onClosed={setPreviewModal}
          SequencesDetails={SequencesDetails}
          ProcessesDetails={ProcessesDetails}
          contentList={contentList}
          setContentList={setContentList}
          setlistData={setlistData}
          listData={listData}
          moduleData={moduleData}
          isLoading={isLoading}
        />
      </Modal>
    </>
  );
};

export default ListPreview;
